import { useQuery } from '@tanstack/react-query';
import { queryKeys, partnersService } from '@v2/services';

export const usePartnerDetails = (partnerId: string | null) => {
  const query = useQuery({
    queryKey: queryKeys.partners.detail(partnerId!),
    queryFn: () => partnersService.getPartnerDetails(partnerId!),
    enabled: !!partnerId,
  });

  return {
    partner: query.data ?? null,
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default usePartnerDetails;
